<template>
    <div class="block-editor google-drive-upload-file">
        <section>
            <div class="title">Channel ID</div>
            <TiptapEditor placeholder="Google Drive Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>Dosyanın yükleneceği Google Drive kanal ID'si</small>
        </section>
        <section>
            <div class="title">Asset ID</div>
            <TiptapEditor placeholder="Supsis Asset ID" :show-attributes="true" v-model="clone.assetId" automation-mode />
            <small>Yüklenecek dosyanın Supsis Asset ID'si</small>
        </section>
        <section>
            <div class="title">Folder ID (Opsiyonel)</div>
            <TiptapEditor placeholder="Google Drive Folder ID" :show-attributes="true" v-model="clone.folderId" automation-mode />
            <small>Dosyanın yükleneceği klasör ID'si (boş bırakılırsa root'a yüklenir)</small>
        </section>
        <section>
            <div class="title">Dosya Adı (Opsiyonel)</div>
            <TiptapEditor placeholder="Yeni dosya adı" :show-attributes="true" v-model="clone.fileName" automation-mode />
            <small>Dosya için özel bir ad (boş bırakılırsa orijinal ad kullanılır)</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleDriveUploadFile",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                assetId: "",
                folderId: "",
                fileName: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-drive-upload-file {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
